import { cn, iaRa, inRn, mString } from 'lib/helpers/utility';

import DocText from 'components/shared/DocumentSheet/DocText';
import DocCard from 'components/shared/DocumentSheet/components/DocCard';
import DocTable from 'components/shared/DocumentSheet/components/DocTable';
import DocNoteBox from 'components/shared/DocumentSheet/components/DocNoteBox';
import DocSectionHead from 'components/shared/DocumentSheet/components/DocSectionHead';
import { DOC_GAPS, DOC_TEXT, withSlotWidths } from 'components/shared/DocumentSheet/lib/docStyles';

const SLOTS = { code: 60, quantity: 40, charge: 96 };

const COLUMNS = withSlotWidths(
  [
    { key: 'name', label: 'Item / service', align: 'left', strong: true },
    { key: 'code', label: 'Code', align: 'left', tabular: true },
    { key: 'quantity', label: 'Qty', align: 'right', tabular: true },
    { key: 'charge', label: 'Expected charge', align: 'right', strong: true, tabular: true }
  ],
  SLOTS
);

export const buildGfeItemsBlock = ({ procedures, total, note }) => {
  const rows = iaRa(procedures).map((procedure, index) => ({
    key: `${procedure?.id ?? procedure?.procedure_code ?? 'item'}-${index}`,
    titleSuffix: procedure?.type || '',
    cells: [
      { value: procedure?.name || 'Service' },
      { value: procedure?.procedure_code || 'TBD' },
      { value: String(inRn(procedure?.quantity ?? procedure?.units, 1) || 1) },
      { value: mString(procedure?.charge), align: 'right' }
    ]
  }));

  if (!rows.length) return null;

  return {
    key: 'gfe-items',
    leading: (
      <div className={DOC_GAPS.section}>
        <DocSectionHead title="Estimated items & services" />
        {note && <DocNoteBox className="mb-2">{note}</DocNoteBox>}
      </div>
    ),
    table: {
      columns: COLUMNS,
      groups: [{ key: 'gfe-items', rows }],
      rowPadClass: 'py-2.5',
      totals: [
        { value: 'Totals (this estimate)', align: 'left', colSpan: 3, tabular: false },
        { value: mString(total), align: 'right' }
      ]
    },
    render: (props) => <DocTable {...props} />
  };
};

export const GfeResponsibility = ({ total }) => (
  <div className={DOC_GAPS.section}>
    <DocText size="xs" className={cn(DOC_TEXT.meta, 'mb-2')}>
      Codes shown as TBD are not final; the practice issues an updated estimate once the service
      code is determined.
    </DocText>
    <DocSectionHead title="Your estimated responsibility" />
    <DocCard className="flex items-start justify-between gap-x-6 px-5 py-4">
      <div className="min-w-0 flex-1">
        <DocText variant="label" size="small" className={DOC_TEXT.microLabel}>
          HOW IT&apos;S ESTIMATED
        </DocText>
        <DocText className={cn(DOC_TEXT.body, 'mt-0.5')}>
          Expected charges for the items listed above. Insurance benefits are not applied to this
          estimate.
        </DocText>
      </div>
      <div className="shrink-0 text-right">
        <DocText variant="label" size="small" className={cn(DOC_TEXT.microLabel, 'text-right')}>
          EST. AMOUNT DUE
        </DocText>
        <DocText size="large" className={cn(DOC_TEXT.cardAmount, 'mt-0.5 text-right')}>
          {mString(total)}
        </DocText>
      </div>
    </DocCard>
    <DocText size="xs" className={cn(DOC_TEXT.closing, 'mt-[14px]')}>
      Estimate only – your insurance payer determines your final balance once your claim is
      processed.
    </DocText>
  </div>
);
